<div class="table-responsive">
  <table class="table table-hover">
    <thead>
    <tr>
      <th class="w-50">{{'doctrine.solution.name'|translate}}</th>
      <th>{{'global.status'|translate}}</th>
      <th>{{'doctrine.option.position'|translate}}</th>
      <th>{{'global.actions'|translate}}</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let solution of getServiceSubjectSolutions();let i = index">
      <tr>
        <td>{{solution.name}}</td>
        <td>{{((solution.status) ? 'global.active' : 'global.inactive')|translate}}</td>
        <td>
          <input class="form-control w-50" (blur)="positionChange(solution.position, solution.id)"
                 [name]="positionItem+i"
                 type="number" [(ngModel)]="solution.position" #positionItem="ngModel">
        </td>
        <td>
          <ng-container>
          <span class="action-button">
            <a class="ripple light ms-2" [routerLink]="['/back-office/service/solution/',solution.id,'edit',serviceSubject.id]">
            <i class="fa fa-pencil fa-lg"></i>
          </a>
          </span>
            <span class="action-button">
                <a class="ripple light ms-2"
                   (click)="openSoftDeleteConfirm(solution.id, solution.name)">
                <i class="fa fa-remove fa-lg"></i>
              </a>
              </span>
          </ng-container>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>

<button type="button" class="btn btn-simple ripple me-2 btn-primary light"
        [routerLink]="['/back-office/service/solution/add',serviceSubject.id]">
  <span class="feather icon-plus"></span> {{'global.add'|translate}}
</button>

<!-- start soft delete modal -->
<app-modal-basic #deleteSolutionModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.actions.delete' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="deleteSolutionModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="solutionName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteSolutionModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDeleteSolution()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
<!-- end soft delete modal -->
